import { useContext, useEffect, useState } from 'react'

import { Select, Switch } from 'antd'
import { useSelector } from 'react-redux'
import { faAt, faCalendar, faDollarSign, faStethoscope, faUser } from '@fortawesome/pro-solid-svg-icons'

import FormItem from '../../../Components/shared/Forms/FormItem'
import Mailing from '../../../Components/shared/Mailing'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import SectorsSelector from '../../../Components/shared/Selectors/SectorsSelector'
import { EUROPEAN_DATE, InstitutionOptions } from '../../../utils/constants'
import { isObject } from '../../../utils'
import { selectUser } from '../../../reducers/UserReducer'
import { getInstitutionSectors } from '../../../utils/api/institution'
import { isInstitutionGroupAdmin } from '../../../utils/roles'
import { InstitutionContext } from '../../InstitutionProvider'

const AcceptIndividualInternshipRequestForm = ({ sectors = [], student, request, compensation = false, onCompensationChange, onSectorSelect, onPeriodsSelect }) => {
  const { options } = useContext(InstitutionContext) ?? {}

  const user = useSelector(selectUser)
  const t = useSelector(selectTranslate)
  const userIsInstitutionGroupAdmin = isInstitutionGroupAdmin(user)

  const [institutionSectors, setInstitutionSectors] = useState(sectors)

  useEffect(() => {
    if ((sectors.length === 0 || userIsInstitutionGroupAdmin) && isObject(request.institution)) {
      getInstitutionSectors(user, request.institution).then(({ data }) => setInstitutionSectors(data))
    }
  }, [sectors.length, user, request.institution, userIsInstitutionGroupAdmin])

  const sectorsList = userIsInstitutionGroupAdmin || sectors.length === 0 ? institutionSectors : sectors
  const durationText = request.duration ? `${request.duration} ${t('internship_request.duration.units.hour')}` : null
  const useInternshipCompensation = isObject(options) && options[InstitutionOptions.INTERNSHIP_COMPENSATION]

  return (
    <div className='h-100 w-100 flex-column'>
      <div className='flex-row w-100'>
        <FormItem className='w-50 pdr-4' icon={faUser} label='form.label.firstname'>
          <div className='pdl-8 fake-gray-input w-100'>
            {student.firstname}
          </div>
        </FormItem>
        <FormItem className='w-50 pdl-4' icon={faUser} label='form.label.lastname'>
          <div className='pdl-8 fake-gray-input w-100'>
            {student.lastname}
          </div>
        </FormItem>
      </div>
      <FormItem icon={faAt} label='form.label.email'>
        <div className='pdl-8 fake-gray-input w-100'>
          <Mailing email={student.email} />
        </div>
      </FormItem>
      <FormItem icon={faStethoscope} label='form.label.sector' required>
        <SectorsSelector
          style={{ width: '100%' }}
          values={sectorsList.length === 0 ? request.sector?.name : (request.sector?.id ?? null)}
          sectors={sectorsList}
          onChange={onSectorSelect}
          disabled={isObject(request?.sector) && !userIsInstitutionGroupAdmin}
        />
      </FormItem>
      <FormItem icon={faCalendar} label='form.label.period' required>
        <Select className='w-100' onChange={onPeriodsSelect} mode='multiple'>
          {request.requestPeriods.map(p => <Select.Option key={p.id} value={p.id}> {p.startDate.format(EUROPEAN_DATE) + ' - ' + p.endDate.format(EUROPEAN_DATE)} </Select.Option>)}
        </Select>
      </FormItem>
      {useInternshipCompensation && (
        <div className='form-item'>
          <FormItem icon={faDollarSign} label='accept_internship_request_modal.compensation'>
            <div className='flex-row jc-between ai-ctr w-100'>
              <div style={{ color: '#d1d1d1', fontSize: 14, fontWeight: 600, paddingLeft: 0, lineHeight: 1.2 }}>
                {t('accept_internship_request_modal.duration')} : {durationText}
              </div>
              <Switch checked={compensation} onChange={onCompensationChange} />
            </div>
          </FormItem>
        </div>
      )}
    </div>
  )
}

export default AcceptIndividualInternshipRequestForm
